import { createStyles } from '@mantine/styles';

export default createStyles(() => ({
  root: {
    backgroundColor: 'transparent',
    cursor: 'pointer',
    padding: 0,
    border: 0,
  },
}));
